<script lang="ts" setup>
import type { CatalogPageRecord, LayoutRecord } from "~~/server/graphql/datocms/generated";
import { z } from "zod";
import { useCategorySlugsToI18n } from "~/composables/useCategorySlugsToI18n";

const layout = await useLayout();
const cmsData = await useCatalogPage();

if (!layout || !cmsData || !cmsData.value) {
  throw create404Error();
}

const paramsSchema = z.object({
  slugs: z.string().optional().or(z.string().array().optional()),
});

const querySchema = z.object({
  term: z.string().optional(),
  filters: z.string().optional(),
});

const { params, query } = useRoute();
const { data: validParamsData } = paramsSchema.safeParse(params);
const { data: validQueryData } = querySchema.safeParse(query);

const categories = await useCategories();

const currentCategoryPath = Array.isArray(validParamsData?.slugs) ? `/${validParamsData?.slugs?.join("/")}` : null;
const currentCategory = currentCategoryPath ? categories.tree.getByPath(currentCategoryPath) : null;

if (!(validQueryData?.term?.length || validQueryData?.filters?.length || currentCategory)) {
  throw create404Error();
}

if (currentCategory) {
  useCategorySlugsToI18n(categories.tree, currentCategory);
}
</script>

<template>
  <div>
    <template v-if="validQueryData?.term?.length || validQueryData?.filters?.length || currentCategory">
      <ProductSearchBase
        :layout="layout! as LayoutRecord"
        :cms-data="cmsData as CatalogPageRecord"
        :category="currentCategory"
        :show="{ categoryDrilldown: true }"
      />
    </template>

    <template v-else>
      <ProductCatalogHeader v-if="categories" view-mode="list" :cms-data="cmsData as CatalogPageRecord" :category-tree="categories.tree" />
      <FeedbackMessage msg="Search term, filters or current category must be provided." type="warning" class="my-md" />
    </template>
  </div>
</template>

<style scoped>

</style>
